import { TextStyle } from '../../styles/text.styles'

export enum TextTag {
  Heading1 = 'h1',
  Heading2 = 'h2',
  Heading3 = 'h3',
  Heading4 = 'h4',
  Paragraph = 'p',
  Strong = 'strong',
  Span = 'span'
}

export const getTextStyleClassName = (style: TextStyle): string => {
  const styleMap: Record<TextStyle, string> = {
    [TextStyle.DisplayXSmall]: 'display-x-small',
    [TextStyle.DisplaySmall]: 'display-small',
    [TextStyle.DisplayMedium]: 'display-medium',
    [TextStyle.DisplayLarge]: 'display-large',

    [TextStyle.TitleSmall]: 'title-small',
    [TextStyle.TitleMedium]: 'title-medium',
    [TextStyle.TitleLarge]: 'title-large',
    [TextStyle.TitleXLarge]: 'title-x-large',

    [TextStyle.HighlightXSmall]: 'highlight-x-small',
    [TextStyle.HighlightSmall]: 'highlight-small',
    [TextStyle.HighlightMedium]: 'highlight-medium',
    [TextStyle.HighlightLarge]: 'highlight-large',

    [TextStyle.BaseXSmall]: 'base-x-small',
    [TextStyle.BaseSmall]: 'base-small',
    [TextStyle.BaseMedium]: 'base-medium',
    [TextStyle.BaseLarge]: 'base-large',

    [TextStyle.UtilitiesSmallHeavy]: 'utilities-small-heavy',
    [TextStyle.UtilitiesMediumHeavy]: 'utilities-medium-heavy',
    [TextStyle.UtilitiesXSmallThin]: 'utilities-x-small-thin',
    [TextStyle.UtilitiesSmallThin]: 'utilities-small-thin',
    [TextStyle.UtilitiesMediumThin]: 'utilities-medium-thin'
  }

  return styleMap[style] || 'base-medium'
}

export const getTextTag = (style: TextStyle): TextTag => {
  switch (style) {
    case TextStyle.TitleSmall:
      return TextTag.Heading3
    case TextStyle.TitleMedium:
      return TextTag.Heading2
    case TextStyle.TitleLarge:
      return TextTag.Heading1
    case TextStyle.DisplayLarge:
      return TextTag.Heading1
    case TextStyle.DisplayMedium:
      return TextTag.Heading2
    case TextStyle.DisplaySmall:
      return TextTag.Heading3
    case TextStyle.DisplayXSmall:
      return TextTag.Heading4
    default:
      if (style.startsWith('Highlight')) {
        return TextTag.Strong
      }

      if (style.startsWith('Base')) {
        return TextTag.Paragraph
      }

      if (style.startsWith('Utilities')) {
        return TextTag.Span
      }

      return TextTag.Paragraph
  }
}
